export default [
  {
    path: '/admin/monthly-compensates',
    name: 'monthly-compensate',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/monthly-compensate/index.vue')
  }
]
